import { memo } from 'react';
import { DROPS_FILTERS_LIST, DropsFilter } from 'root/src/client/v2/_pages/drops/fixtures/drops.constants';
import { Badge } from 'root/src/client/v2/common/components/badge/Badge';
import { useDropEventListFiltersContext } from 'root/src/client/v2/_pages/drops/contexts/dropEventListFilters.context';
import { useTabAvailableFilters } from 'root/src/client/v2/_pages/drops/hooks/useTabAvailableFilters';
export const DropsListFilter = memo(() => {
    const { isLoading, defaultFilter, availableFilters } = useTabAvailableFilters();
    const { filter, onFilterChange } = useDropEventListFiltersContext();
    const filtersList = useDropFiltersList(availableFilters);
    if (isLoading) {
        return <SkeletonDropsListFilter />;
    }
    return (<ul role="list" className="flex justify-center sm:justify-start flex-wrap gap-3 sm:gap-2">
			{filtersList.map((option) => {
            const isActive = filter === DropsFilter.Default
                ? option.value === defaultFilter
                : option.value === filter;
            return (<li key={option.value}>
						<button type="button" onClick={() => onFilterChange(option.value)}>
							<DropFilterBadge isActive={isActive}>{option.title}</DropFilterBadge>
						</button>
					</li>);
        })}
		</ul>);
});
const useDropFiltersList = (availableFilters) => {
    return DROPS_FILTERS_LIST.filter((option) => {
        return availableFilters.includes(option.value);
    });
};
export const DropFilterBadge = memo((props) => {
    const { isActive, children } = props;
    return (<Badge data-active={isActive} className="capitalize data-[active=true]:motion-safe:animate-slide-up hover:brightness-100 motion-safe:duration-150 bg-primary brightness-50 data-[active=true]:brightness-100">
			{children}
		</Badge>);
});
const SkeletonDropsListFilter = () => {
    return (<div className="flex justify-center sm:justify-start flex-wrap gap-3 sm:gap-2">
			<Badge className="animate-skeleton-loading w-[50px] h-[28px]"/>
			<Badge className="animate-skeleton-loading w-[120px] h-[28px]"/>
			<Badge className="animate-skeleton-loading w-[70px] h-[28px]"/>
		</div>);
};
